const docToQuizFeedbacks = ['Generate more', 'Funnier', 'Easier', 'Harder', 'More question types']
const aiSlidesGeneratorFeedbacks = ['Generate more', 'Funnier', 'Easier', 'Harder']
const aiConversationPendingMessages = ['Got it! Please wait a moment...', 'Processing your request...', 'Working on your presentation...', 'Analyzing your content...', 'Structuring ideas...', 'Arranging orders...', 'Creating your slides...']

// AI SLIDES GENERATOR
const AI_ROLE_USER = 'USER'
const AI_ROLE_SYSTEM = 'SYSTEM'
const AI_SYSTEM_GREETINGS_MESSAGE_TYPE = 'greetings'
const AI_SYSTEM_PENDING_MESSAGE_TYPE = 'generating-slide'
const AI_SYSTEM_ADDED_SLIDE_MESSAGE_TYPE = 'added-slide'
const AI_SYSTEM_ERROR_MESSAGE_TYPE = 'system-error'
const AI_SYSTEM_SUCCESS_MESSAGE_TYPE = 'generate-successful'
const AI_SYSTEM_GENERATION_STOPPED_MESSAGE_TYPE = 'generation-stopped'
const AI_USER_DOC_TO_SLIDE_MESSAGE_TYPE = 'generate-from-doc'
const AI_DOC_TO_SLIDE_ADD_MESSAGE_FROM = 'Import PPT/PDF'
const AI_KEYWORD_BACKGROUND_PURPOSE = 'background'
const AI_KEYWORD_CONTENT_PURPOSE = 'content'
const AI_KEYWORD_QUESTION_IMAGE_PURPOSE = 'questionImage'
const AI_KEYWORD_SLIDE_OPTION_IMAGE_PURPOSE = 'slideOptionImage'
const AI_IMAGE_SEARCH_BAR_STOCK_PHOTO_TYPE = 'Stock Photo'
const TYPE_SLIDE = 'SLIDE'
const TYPE_PRESENTATION = 'PRESENTATION'

export default {
  docToQuizFeedbacks,
  aiSlidesGeneratorFeedbacks,
  aiConversationPendingMessages,

  // AI SLIDES GENERATOR
  AI_ROLE_USER,
  AI_ROLE_SYSTEM,
  AI_SYSTEM_GREETINGS_MESSAGE_TYPE,
  AI_SYSTEM_PENDING_MESSAGE_TYPE,
  AI_SYSTEM_ADDED_SLIDE_MESSAGE_TYPE,
  AI_SYSTEM_ERROR_MESSAGE_TYPE,
  AI_SYSTEM_SUCCESS_MESSAGE_TYPE,
  AI_SYSTEM_GENERATION_STOPPED_MESSAGE_TYPE,
  AI_USER_DOC_TO_SLIDE_MESSAGE_TYPE,
  AI_DOC_TO_SLIDE_ADD_MESSAGE_FROM,
  AI_KEYWORD_BACKGROUND_PURPOSE,
  AI_KEYWORD_CONTENT_PURPOSE,
  AI_KEYWORD_QUESTION_IMAGE_PURPOSE,
  AI_KEYWORD_SLIDE_OPTION_IMAGE_PURPOSE,
  AI_IMAGE_SEARCH_BAR_STOCK_PHOTO_TYPE,
  TYPE_SLIDE,
  TYPE_PRESENTATION,
}
